import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl, FormBuilder, Validators } from '@angular/forms'
import { Subscription, map, debounceTime, filter, tap } from 'rxjs'
import { EmployeeAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import { WebService } from 'src/app/services/api/web.service'

@Component({
  selector: 'app-employee-selector',
  templateUrl: './employee-selector.component.html',
  styleUrls: ['./employee-selector.component.scss']
})
export class EmployeeSelectorComponent implements OnInit {
  @Input() isMandatory: Boolean = true

  @Output() selectedValueChange: EventEmitter<string> = new EventEmitter<string>()
  @Output() selectedEmployee: EventEmitter<EmployeeAPIModel> = new EventEmitter<EmployeeAPIModel>()
  @Output() onChange: EventEmitter<string> = new EventEmitter<string>()

  employees: EmployeeAPIModel[] = []
  employeesSubscription$: Subscription
  employeeFormControl: FormControl = new FormControl('', Validators.required)
  employeeControlSubscription$: Subscription

  constructor(private webService: WebService, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.employeeControlSubscription$ = this.employeeFormControl.valueChanges
      .pipe(
        tap(value => this.onSelect(null)),
        debounceTime(500),
        map(value => value.trim()),
        filter(value => value.length >= 3),
        tap(value => this._filter(value))
      )
      .subscribe()
  }

  createEmployeeForm() {
    this.formBuilder.group({})
  }

  callGetEmployeeListAPI(employeeCode: string) {
    this.employees = []
    this.employeesSubscription$ = this.webService
      .post('/employee/list?pageNo=0&limit=1000000', { employeeCode })
      .pipe(map((data: PaginatedAPI<EmployeeAPIModel>) => data))
      .subscribe(data => {
        this.employees = data?.content
      })
  }

  onSelect(selectedValue: string) {
    this.selectedValueChange.emit(selectedValue)
    this.selectedEmployee.emit(this.employees.filter(employee => employee.id === selectedValue)?.[0])
  }

  private _filter(value: string) {
    const filterValue = this._normalizeValue(value)
    this.callGetEmployeeListAPI(filterValue)
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '')
  }

  displayFn(value?: string) {
    return value && this.employees ? this.employees.filter(_ => _.id === value)[0].employeeCode : undefined
  }

  handleInputChange(value: string) {
    this.onChange.emit(value)
  }

  disableSpecialChars(event: KeyboardEvent): void {
    const allowedChars = /^[a-zA-Z0-9. ]*$/ // only Dot . is allowed
    if (!allowedChars.test(event.key)) {
      event.preventDefault()
    }
  }

  ngOnDestroy() {
    this.employeesSubscription$?.unsubscribe()
    this.employeeControlSubscription$?.unsubscribe()
  }
}
